import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import AboutPage from './pages/AboutPage';
import Navbar from './components/Navbar';
import './App.css'; // Ensure this file contains the CSS for transitions

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Default Route: Redirect '/' to '/home' */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/about" element={<AboutPage />} />
        {/* Unknown address: go back to the home page instead of a blank page */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
